module.exports = __webpack_public_path__ + "static/media/product-ranking.a17e8d9f.png";